<script setup lang="ts"></script>

<template>
  <v-icon icon="fat fa-chevron-down" :size="14"></v-icon>
</template>
